module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedBoldItalic.1deaa87.woff";